import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-festive-banners',
  templateUrl: './festive-banners.component.html',
  styleUrls: ['./festive-banners.component.css']
})
export class FestiveBannersComponent implements OnInit {
  private window: Window;
  constructor(@Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)){
      this.document.body.style.paddingTop = '90px';
    }
  }

}
